import { render, staticRenderFns } from "./vGesRenIndividual.vue?vue&type=template&id=2a66d896&scoped=true&"
import script from "./vGesRenIndividual.vue?vue&type=script&lang=js&"
export * from "./vGesRenIndividual.vue?vue&type=script&lang=js&"
import style0 from "./vGesRenIndividual.vue?vue&type=style&index=0&id=2a66d896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a66d896",
  null
  
)

export default component.exports